import { useState, useMemo } from 'react'

export const useMenuData = (allProducts, allCategories) => {
    const productMap = useMemo(() => {
        const map = new Map()
        allProducts.forEach(p => map.set(p.id, p))
        return map
    }, [allProducts])

    const categoryMap = useMemo(() => {
        const map = new Map()
        allCategories.forEach(c => map.set(c.id, c))
        return map
    }, [allCategories])

    const productToCategoryMap = useMemo(() => {
        const map = new Map()
        allCategories.forEach(cat => {
            cat.products?.forEach(prodId => {
                map.set(prodId, cat.id)
            })
        })
        return map
    }, [allCategories])

    return {
        productMap,
        categoryMap,
        productToCategoryMap,
        getProduct: (id) => productMap.get(id),
        getCategory: (id) => categoryMap.get(id),
        getProductCategory: (productId) => productToCategoryMap.get(productId)
    }
}
